module.exports = __webpack_public_path__ + "assets/img/81f1-pw.svg";